<template>
  <div>

    <b-card-header header-tag="header" class="p-1" role="tab">        
        <b-row>
          <b-col cols="7">
            <b-icon  v-on:click="collapseIconClick" v-bind:icon="!this.lineDetailsCollapsed ? 'chevron-double-up' : 'chevron-double-down'" 
            class="chevronIcon"
              v-b-tooltip.hover.top.v-secondary title="Collapse/Expand this Line's details below, if disposition is 'Providing Quote'"
            ></b-icon> 
            <strong>Line {{this.line_index + 1}}: </strong>{{request.nsn}} <small>{{request.description}} </small>
          </b-col>

          <!-- selector for Quote/NoQuote/WillAdvise -->
          <b-col cols="2">
              <b-form-select
              v-model="lineDisposition" 
              size="sm" 
              :options="line_disposition_options" 
              v-on:change="dispositionChanged"
              ></b-form-select>
          </b-col>

          <!-- dropdown of no-quote reasons -->
          <b-col cols="3" v-if="lineDisposition === 1">
              <b-form-select  
              ref="noQuoteSelector"
              v-model="response.no_quote_classification"
              size="sm" 
              :options="no_quote_classifications"
              :state="classificationState"
              v-on:change="noQuoteClassificationSelected"
              ></b-form-select>

              <b-form-input
              v-if="response.no_quote_classification === 'Other'"
              v-model="response.no_quote_other_reason"
              size="sm"
              placeholder="Please specify..."
              class="mt-1"
              :state="otherReasonState"
              ></b-form-input>
          </b-col>

          <!-- Will-Advise calendar -->
          <b-col cols="3" v-if="lineDisposition === 2">
                <b-form-datepicker 
                ref="willAdviseDatePicker"
                v-model="response.will_advise_dt" 
                size="sm" 
                :state="willAdviseDateState"
                :min="willAdviseMinDate"  
                :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                placeholder="Choose a date"
                v-on:input="willAdviseDateSelected"
                ></b-form-datepicker>
          </b-col>
        </b-row>              
    </b-card-header>

    <b-collapse v-bind:id="'lineDetails-' + key" v-bind:visible="lineDetailsCollapsed">
    <b-card-body >
      <b-form-row>
        <b-col lg="4" md="8" sm="12">
          <b-form-group v-bind:id="'nsn-' + key" label="NSN:" v-bind:label-for="'input-nsn-' + key">
            <b-input-group   size="sm"  >
              <b-input-group-prepend is-text size="md"> 
                No NSN
                <input type="checkbox" style="margin-left: 2mm;"
                v-on:change="emptyNSN"/>
              </b-input-group-prepend>

              <b-form-input
              size="lg"
                v-bind:id="'input-nsn-' + key"
                v-model="response.nsn"
                placeholder="Enter NSN"
                readonly
              >
              </b-form-input>
              <!-- the appended button that creates the modal popup --> 
              <b-input-group-append >
                <alternate-part-info-button 
                :id_key="'nsn-' + key"
                :dataType="`NSN`"
                :externalPartInfo="response.alternate_nsn"
                ></alternate-part-info-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>




        
        <b-col lg="4" md="6" sm="12">
          <b-form-group v-bind:id="'part_number-' + key" label="Part Number:" v-bind:label-for="'input-part_number-' + key">
            <b-input-group   size="sm"  >
            <b-form-select
             size="sm"
              v-bind:id="'input-part_number-' + key"
              v-b-tooltip.hover.top.v-secondary
                :title="'Click the button on the right to enter an alternate part number'"
              placeholder="Select a Part Number"
              v-model="response.part_number"
              v-bind:list="'input-list-part_number-' + key"
              :state="no_quote ? null : (response.part_number ? null : false)"
              :options="partDetailOptions" 
              v-on:input="partNumberSelected"
            ></b-form-select>
            <b-input-group-append >
              <alternate-part-info-button 
              :id_key="'partNumber-' + key"
              :dataType="`PartNumber`"
              :externalPartInfo="response.alternate_part_number"
              ></alternate-part-info-button>
            </b-input-group-append> 
            </b-input-group>         
          </b-form-group>
        </b-col>



        <b-col lg="4" md="6" sm="12">
          <b-form-group v-bind:id="'description-' + key" label="Description:" v-bind:label-for="'input-description-' + key">
            <b-form-input
             size="sm"
              v-bind:id="'input-description-' + key"
              v-model="response.description"
              placeholder="Enter Description"
              :state="(response.description != null && response.description.trim().length > 0)"
            ></b-form-input>
          </b-form-group>
        </b-col>
        
        
      </b-form-row>

      <b-form-row>
          <b-col lg="4" md="6" sm="12">
          <b-form-group v-bind:id="'weight_per_uom-' + key" label="Weight in lbs.:" v-bind:label-for="'input-weight_per_uom-' + key" >
            <b-input-group append="lbs."  size="sm"  >
              <b-form-input
               size="sm"
                v-bind:id="'input-weight_per_uom-' + key"
                v-model="response.weight_per_uom"
                placeholder="Weight (in lbs)"
                :number="true"
                type="number"
                min="0"
              >
              </b-form-input>
            </b-input-group>
          </b-form-group>
          
        </b-col>


        <b-col lg="4" md="6" sm="12">
          <b-form-group v-bind:id="'coo-' + key" label="COO:" v-bind:label-for="'input-coo-' + key"
          v-b-tooltip.hover.bottom.v-secondary title="Country of Origin">
            <b-form-select 
             size="sm"
              :inputId="'input-coo-' + key"
              v-model="response.coo"
              placeholder="Enter COO"
              :options="coos"
            ></b-form-select>
          </b-form-group>
        </b-col>

        <b-col lg="4" md="6" sm="12">
          <b-form-group v-bind:id="'moq-' + key" label="MOQ:" v-bind:label-for="'input-moq-' + key"
          v-b-tooltip.hover.bottom.v-secondary title="Minimal Order Quantity"
          >
            <b-form-input
             size="sm"
              v-bind:id="'input-moq-' + key"
              v-model="response.minimum_order_quantity"
              placeholder="Enter MOQ"
              :number="true"
              
              type="number"
              min="0"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-form-row>


      <!-- CLAUSES -- these have been archived and the feature is no longer in use.
         Was exclusively for the prior BC client "L3.""  The Sedna API now always
          returns null or an empty list for this, intentionally.  See 
         code comments in Sedna.API solution.

      <b-form-group v-if="request.clauses && request.clauses.length > 0" v-bind:id="'clauses-' + key" label="Clauses:" v-bind:label-for="'input-clauses-' + key">
        <b-card no-body>
          <b-list-group flush>
            <b-list-group-item v-for="(request_clause, clause_index) in request.clauses" :key="clause_index" >
              {{request_clause}}
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-form-group>

      -->

      <additional-cost-form
        v-bind:response="response"
        v-bind:additional_costs="additional_costs"
        v-bind:id="key"
        v-bind:caption="'Add per-line costs'"
        v-on:addAdditionalCost="addAdditionalCost" 
        v-on:removeAdditionalCost="removeAdditionalCost"
      />

      <b-form-group v-if="request.attachments && request.attachments.length > 0" v-bind:id="'attachments-' + key" label="Attachments:" v-bind:label-for="'input-attachments-' + key">
        <b-card no-body>
          <b-row v-if="request.attachments && request.attachments.length > 0" no-gutters>
            <b-col lg="3" md="4" sm="12" v-for="(request_attachment, attachment_index) in request.attachments" :key="attachment_index" >
              <b-form-group v-bind:id="attachment_index + key" class="list-group-item" style="margin-bottom: 0">
                <b-link v-bind:href="request_attachment.url" target="_blank">{{request_attachment.filename}}</b-link>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
      </b-form-group>
    
      <b-form-group v-bind:id="'quantities-' + key" v-bind:label-for="'input-quantities-' + key">
        <b-card>
          <b-form-group v-for="(response_quantity, quantity_index) in response.quantities" :key="quantity_index">
            <quantity-form 
              v-on="$listeners"
              v-on:change="checkAllNoQuoted"
              v-bind:response="response_quantity" 
              v-bind:quantity_index="quantity_index" 
              v-bind:line_index="line_index"        
              v-bind:line_condition_options="line_condition_options" 
              v-bind:id="key + '-' + quantity_index" 
            />
          </b-form-group>

          <b-container fluid>
            <b-form-row>
              <b-col cols="1">
                <b-button block variant="info" class="btn-sm"  v-on:click="$emit('addQuantity', line_index)"><i class="fa fa-plus" /></b-button>
              </b-col>
              <b-col cols="11" align-self="center">
                 Add Quantity Break 
              </b-col>
            </b-form-row>
          </b-container>
        </b-card>
      </b-form-group>

      
      <b-form-group v-bind:id="'requirements-' + key" v-bind:label-for="'input-requirements-' + key">
        <b-card>
          <strong>Opportunity Requirements</strong>
          <p>Answer any questions or advise in the comment section below if you are unable to meet a specific requirement listed.</p>
          <b-form-group v-for="(requirement, requirement_index) in (request.requirements || []).filter(r => r.requirement_type != '2')" :key="requirement_index">            <requirement-form
            v-if="request.requirements && request.requirements.length >= 1"
            v-on="$listeners"
            v-bind:response="requirement"
            v-bind:requirement_index="requirement_index"
            v-bind:line_index="line_index"
            v-bind:id="key + '-' + requirement_index"
            />
          </b-form-group>
          <b-form-input :readonly="true" placeholder="There are no specific solicitation requirements for this opportunity" v-if="request.requirements && request.requirements.length == 0"></b-form-input>
          <b-col cols="3" class="mt-4">
            <b-button v-b-toggle.clause-collapse block variant="info" class="btn-sm" v-on:click="toggleClauseCollapse" v-if="request.requirements && request.requirements.length > 0">
              FAR's
              <b-icon v-bind:icon="!this.clausesCollapsed ? 'chevron-double-up' : 'chevron-double-down'" 
              class="chevronIcon"
              ></b-icon>
            </b-button>
          </b-col>
          <br/>
          <b-collapse id="clause-collapse" class="mt-2">
            <b-card>
              <b-form-group v-for="(requirement, requirement_index) in (request.requirements || []).filter(r => r.requirement_type == '2')" :key="requirement_index">                <requirement-form
                v-if="request.requirements && request.requirements.length >= 1"
                v-on="$listeners"
                v-bind:response="requirement"
                v-bind:requirement_index="requirement_index"
                v-bind:line_index="line_index"
                v-bind:id="key + '-' + requirement_index"
                />
              </b-form-group>
            </b-card>
          </b-collapse>
        </b-card>
      </b-form-group>

    </b-card-body>
    </b-collapse>
  </div>
</template>

<script>
import QuantityForm from './FormQuantity';
import RequirementForm from './FormLineRequirement';
import AdditionalCostForm from './FormAdditionalCost';
import AlternatePartInfoButton from './AlternatePartInfoButton';
import { eventBus } from '../../main.js'

const lineDisposition_QUOTING = 0;
const lineDisposition_NOQUOTING = 1;
const lineDisposition_WILLADVISE = 2;

export default {
  name: 'rfq-line-form',
  props: [
    'request',
    'response',
    'coos',
    'no_quote_classifications',
    'line_index',
    'additional_costs',
    'line_disposition_options',
    'line_condition_options' 
  ],
  components: {
    'quantity-form': QuantityForm,
    'requirement-form': RequirementForm,
    'additional-cost-form': AdditionalCostForm,
    'alternate-part-info-button': AlternatePartInfoButton
  },

  data() {
    
    return {
      lineDisposition: 0,
      willAdviseMinDate: new Date(),
      lineDetailsCollapsed: true,
      clausesCollapsed: true,
      partDetailOptions: [],
      originalPartDetailOptions: []  // because users can add a new one, we need to be able to restore this list.
    }
  },
  

  computed: {
    key: function () {
      return 'rfq_line_' + this.request.id
    },
    no_quote: function() {
      return !this.response.quantities.length;
    },

    classificationState: function () {
      var state = false;
      var hasNoQuoteReason = this.response.no_quote_classification != null;
      if(hasNoQuoteReason) { return true; }
      return state;
    },

    otherReasonState: function () {
      var state = false;
      var hasNoQuoteReason = this.response.no_quote_other_reason != null;
      if(hasNoQuoteReason) { return true; }
      return state;
    },
  
    willAdviseDateState: function () {
      var hasWillAdviseDate = this.response.will_advise_dt != null;
      if(hasWillAdviseDate) { return true; }
      return false;
    },
    

    checkAllNoQuoted: function () {
      var state = false;
      var allQuantitiesNoQuoted = this.response.quantities.every(q => q.no_quote == true);
      if(allQuantitiesNoQuoted) { 
        this.checkNoQuoted();
        }
      return state;
    },
  },
  methods: {
    collapseIconClick: function() {
      //console.log("icon clicked; current value = " + this.lineDisposition)

      // Only allow user to toggle the visibility if the current disposition is "Quoting."
      // Otherwise it must remain hidden. 
      if(this.lineDisposition === lineDisposition_QUOTING) 
        {
          this.lineDetailsCollapsed = !this.lineDetailsCollapsed
          //this.$root.$emit('bv::toggle::collapse', 'lineDetails-' + this.key);
        }
    },

    toggleClauseCollapse: function() {
      if (this.clausesCollapsed) {
        this.clausesCollapsed = false;
      } else {
        this.clausesCollapsed = true;
      }
    },

    checkNoQuoted: function() {
      var allQuantitiesNoQuoted = this.response.quantities.every(q => q.no_quote == true);
      if(allQuantitiesNoQuoted) { 
        this.response.no_quote_classification = null;
        this.response.will_advise_dt = null;
        this.response.disposition = 'NOQUOTING';
        this.lineDisposition = 1;
        this.lineDetailsCollapsed = false;
        }
    },

    emptyNSN: function () {
      this.response.nsn = "";
    },
    
    addAdditionalCost: function() {
      this.response.additional_costs.push({ per_unit: true });
    },
    removeAdditionalCost: function(additional_cost_index) {
      this.response.additional_costs.splice(additional_cost_index, 1);
    },
    dispositionChanged: function(event) {
      //console.log("dispositionChanged fired");

      // always blank these out until the user picks a value
      this.response.no_quote_classification = null;
      this.response.will_advise_dt = null;
      console.log(this.request.requirements);
      switch(event)
      {
        case lineDisposition_QUOTING:
          this.response.disposition = 'QUOTING';
          this.lineDetailsCollapsed = true;
          break;

        case lineDisposition_NOQUOTING:
          this.response.disposition = 'NOQUOTING';
          this.lineDetailsCollapsed = false;
          this.$refs.noQuoteSelector.focus();
          break;

        case lineDisposition_WILLADVISE:
          this.response.disposition = 'WILLADVISE';
          this.lineDetailsCollapsed = false;
          this.$refs.willAdviseDatePicker.focus();
          break;
      }
    },
    noQuoteClassificationSelected: function(noQuoteString)
    {
        this.response.will_advise_dt = null;
        
        if(noQuoteString != null)
        {
          this.response.no_quote_classification = noQuoteString;
        }
    },

    willAdviseDateSelected: function(will_advise_dt)
    {
        this.response.no_quote_classification = null;

        if(will_advise_dt != null)
        {
          this.response.will_advise_dt = will_advise_dt;
          console.log("this.response.will_advise_dt = " + this.response.will_advise_dt);
        }
    },

    partNumberSelected: function(partNumber) {
      console.log("partNumberSelected fired");
      this.response.part_number = partNumber;
      
      var partDetails = this.request.part_details.find(pd => { return pd.part_number === partNumber });
      this.response.weight_per_uom = (partDetails == undefined) ? null : partDetails.weight_per_uom;
      ;
    }
  },

  created() {
      eventBus.$on('alternatePartInfo_Changed', (data) => {

        if(data[0] === "NSN" )
        {
          this.response.nsn = this.response.alternate_nsn.name;
        }

        if(data[0] === "PartNumber")
        {
          // reset the list to original values, add the new one, and set the dropdown
          this.partDetailOptions = JSON.parse(JSON.stringify(this.originalPartDetailOptions));
          this.partDetailOptions.push(this.response.alternate_part_number.name);
          this.response.part_number = this.response.alternate_part_number.name;
        }
    });
  },

  mounted() {
    console.log("FormLine.vue:this.request");
    console.log(this.request); 
    console.log("FormLine.vue:this.response");
    console.log(this.response); 

    // set default value
    this.lineDisposition = lineDisposition_QUOTING;

    if(this.request.no_quote_classification != null)
    {
      // console.log("this.request.no_quote_classification = " + this.request.no_quote_classification);
      // console.log("this.response.no_quote_classification = " + this.response.no_quote_classification);
      this.lineDisposition = lineDisposition_NOQUOTING;
      this.lineDetailsCollapsed = false;
      //console.log("this.lineDisposition = " + this.lineDisposition);
  }    

    if(this.request.will_advise_dt != null)
    {
      // console.log("this.request.will_advise_dt = " + this.request.will_advise_dt);
      // console.log("this.response.will_advise_dt = " + this.response.will_advise_dt);
      this.lineDisposition = lineDisposition_WILLADVISE;
      this.lineDetailsCollapsed = false;
      //console.log("this.lineDisposition = " + this.lineDisposition);
   }

    // if we are reviewing a quote (not creating the first one), we need to set the response-level properties
    if(this.request.part_number != undefined)
    {
      console.log("this.request.part_number = " + this.request.part_number );
      console.log(this.request.part_details);
      var chosenPart = this.request.part_details.find(pd => pd.part_number.trim() === this.request.part_number.trim() );
      if(chosenPart != null && chosenPart != undefined)
      {
        this.response.weight_per_uom = chosenPart.weight_per_uom;
      }
    }


    const tomorrow = new Date(new Date().getFullYear(),new Date().getMonth() , new Date().getDate()+1);
    this.willAdviseMinDate = new Date(tomorrow);

    var partsOptionsList = [];
    this.request.part_details.forEach(pd => { 
      var opt = { 'text': pd.part_number, 'value': pd.part_number};
      partsOptionsList.push(opt)
    });
    this.partDetailOptions = partsOptionsList;
    this.originalPartDetailOptions = JSON.parse(JSON.stringify(this.partDetailOptions));


  }

}
</script>

<style scoped>
.chevronIcon {
  padding-left: 5px;
  padding-right: 25px;
  margin-top: 8px;
  cursor: pointer;
  color: darkred;

}

.form-group {
  margin-bottom: 0.75rem;
}

.card-header {
   
}
</style>